// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

import pwaInstallPrompt from "pwa-install-prompt";

new pwaInstallPrompt();
